import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from "../../environments/environment";

export const authConfig: AuthConfig = {

  // Url of the Identity Provider (https://auth.staging.konekto.be/realms/EuroportsInlandTerminals/.well-known/openid-configuration)
  issuer: environment.issuer,
  // issuer: 'http://localhost:8442/auth/realms/konekto',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin,

  postLogoutRedirectUri: window.location.origin,

  // The SPA's id. The SPA is registered with this id at the auth-server
  clientId: 'client:webapp:public',

  responseType: 'code',

  // Sets the scope for the permissions the client should request
  // OIDC defines the first two scopes. The other ones are usecase-specific
  scope: 'openid email' +
    // Purchase Orders
    ' eit:purchase-order.create' +
    ' eit:purchase-order.read' +
    ' eit:purchase-order.update' +
    ' eit:purchase-order.delete' +
    ' eit:purchase-order:greenlight.update' +
    ' eit:purchase-order:amount-validation.update' +
    // Suppliers
    ' eit:supplier.read' +
    ' eit:supplier.update' +
    // Delivery Orders
    ' eit:delivery-order.create' +
    ' eit:delivery-order.update' +
    ' eit:delivery-order.read' +
    // Delivery Addresses
    ' eit:delivery-address.read' +
    ' eit:delivery-address.create' +
    ' eit:delivery-address.update' +
    ' eit:delivery-address.delete' +
    // Divisions, Departments, Sites
    ' eit:division.read' +
    ' eit:department.read' +
    ' eit:site.read' +
    // Accounts
    ' eit:account.read' +
    ' eit:account.update' +
    // VAT Codes
    ' eit:vat-code.read' +
    ' eit:vat-code.update' +
    // Invoices
    ' eit:invoice.create' +
    ' eit:invoice.update' +
    ' eit:invoice.delete' +
    // Invoice documents
    ' eit:invoice-document.read' +
    ' eit:invoice-document.update',

  strictDiscoveryDocumentValidation: false,

  showDebugInformation: true,

  timeoutFactor: 0.8,
};

